import React from 'react';
import SelectFancy from '@atoms/SelectFancy';
import usePrefixOptions from '@hooks/usePrefixOptions';

const SelectPrefixes = () => {
    const { isLoading, data, error } = usePrefixOptions();

    if (error) {
        return null;
    }

    return <SelectFancy label="Prefix" name="prefix" options={data} isLoading={isLoading} />;
};

export default SelectPrefixes;
